import React from 'react';
import Service from '@superdata/basic-data-service';

const Logo = (props: any) => {
  const { config } = window.Service ?? Service;
  const sys_small_logo: string = config.getField('sys_small_logo') as string;
  return (
    <img src={sys_small_logo} alt="" className={props.className} />
  )
};

export default Logo;
